import type { SafeHtml } from 'kerfjs';

import { documentAnnotations, me } from '../../../../../data/state.js';
import type { GalleryPreview } from './gallery-types.js';

export function GalleryImageStage({
  active,
  filename,
  readOnly,
}: {
  active: GalleryPreview;
  filename: string;
  readOnly: boolean;
}): SafeHtml {
  const zoom = active.zoom ?? 1;
  return (
    <div class="gallery-image-stage document-preview-stage" data-document-gallery-stage>
      <div class="document-preview-canvas">
        <div class="document-preview-image-wrap" style={`zoom: ${String(zoom)}`}>
          <img
            class="document-preview-image"
            src={active.url}
            alt={filename}
            data-document-annotation-image={active.annotating === true && !readOnly ? '' : undefined}
            role={active.annotating === true && !readOnly ? 'button' : undefined}
            tabindex={active.annotating === true && !readOnly ? '0' : undefined}
            aria-label={active.annotating === true && !readOnly ? 'Place annotation at image center' : undefined}
          />
          {active.annotating === true
            ? documentAnnotations.value.map((annotation, markerIndex) => {
                const canModerate = me.value?.roles.some((role) => role === 'reviewer' || role === 'admin') ?? false;
                const movable =
                  !readOnly &&
                  active.annotationSaving !== true &&
                  (annotation.authorMemberId === me.value?.memberId || canModerate);
                return (
                  <span
                    class="document-preview-marker"
                    style={`left: ${String(annotation.x * 100)}%; top: ${String(annotation.y * 100)}%`}
                    title={`${String(markerIndex + 1)}. ${annotation.body}`}
                    data-document-annotation-marker={movable ? '' : undefined}
                    data-item-id={annotation.id}
                    data-annotation-x={String(annotation.x)}
                    data-annotation-y={String(annotation.y)}
                    role={movable ? 'button' : undefined}
                    tabindex={movable ? '0' : undefined}
                    aria-label={movable ? `Move annotation ${String(markerIndex + 1)}: ${annotation.body}` : undefined}
                  >
                    {String(markerIndex + 1)}
                  </span>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
}
